module.exports = __webpack_public_path__ + "static/media/qrcode.795ae5a4.png";